export default __webpack_public_path__ + "static/media/pizzab-red.1b7ce954.png";